const parseQueryParams = (url) => {
  const params = {};
  try {
    const regex = /[?&]([^=#]+)=([^&#]*)/g;

    let match;
    while ((match = regex.exec(url))) {
      params[match[1]] = match[2];
    }
  } catch (e) {}
  return params;
};

const rewardExpireTimeFormat = (expireOn) => {
  if (expireOn) {
    const diffTime = Math.abs(new Date(expireOn) - new Date());
    const diffInDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffInDays > 1 && diffInDays < 20) {
      return diffInDays + " d";
    }

    if (diffInDays > 0 && diffInDays < 1) {
      const diffInHours = Math.ceil(diffTime / (1000 * 60 * 60));
      return diffInHours + " h";
    }
  }
  return null;
};

const rewardExpired = (expireOn) => {
  if (expireOn) {
    const diffTime = Math.abs(new Date(expireOn) - new Date());
    const diffInHours = Math.ceil(diffTime / (1000 * 60 * 60));
    if (diffInHours <= 0) {
      return true;
    }
  }
  return false;
};

const validateParams = (params) => {
  if (!Array.isArray(params)) {
    throw new Error("Params must be an array.");
  }

  if (params.length === 0) {
    throw new Error("Params array cannot be empty.");
  }

  if (params.length > 2) {
    throw new Error("Params array must contain only a max of two items.");
  }

  params.forEach((item, index) => {
    if (typeof item !== "object" || item === null || Array.isArray(item)) {
      throw new Error(`Item at index ${index} must be a non-null object.`);
    }

    const keys = Object.keys(item);

    // * Must contain only "key" and "value".
    if (keys.length !== 2 || !keys.includes("key") || !keys.includes("value")) {
      throw new Error(
        `Item at index ${index} must only contain 'key' and 'value' properties.`
      );
    }

    // * Both key and value must be strings.
    if (typeof item.key !== "string" || typeof item.value !== "string") {
      throw new Error(
        `'key' and 'value' in item at index ${index} must both be strings.`
      );
    }
  });

  return params;
};

const setOtpRetryTimeoutData = (params = []) => {
  try {
    const validatedParams = validateParams(params);

    validatedParams.forEach((item) => {
      const { key, value } = item;
      localStorage.setItem(key, value);
    });
  } catch (err) {
    console.error("Failed to set local storage data", err);
  }
};

const removeOtpRetryTimeoutData = (params = []) => {
  try {
    if (!Array.isArray(params)) {
      throw new Error("Params must be an array.");
    }

    if (params.length === 0) {
      throw new Error("Params array cannot be empty.");
    }

    if (params.length > 2) {
      throw new Error("Params array must contain only a max of two items.");
    }

    if (!params.every((key) => typeof key === "string"))
      throw new Error("Params array items must always be strings.");

    params.forEach((key) => {
      localStorage.removeItem(key);
    });
  } catch (err) {
    console.error("Failed to set local storage data", err);
  }
};

export {
  parseQueryParams,
  rewardExpireTimeFormat,
  rewardExpired,
  setOtpRetryTimeoutData,
  removeOtpRetryTimeoutData,
};
